import { render, staticRenderFns } from "./MessagesModal.vue?vue&type=template&id=21928ae6&scoped=true"
import script from "./MessagesModal.vue?vue&type=script&lang=js"
export * from "./MessagesModal.vue?vue&type=script&lang=js"
import style0 from "./MessagesModal.vue?vue&type=style&index=0&id=21928ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21928ae6",
  null
  
)

export default component.exports